module.exports = __webpack_public_path__ + "fonts/ProximaNovaCondensedW05-Rg.c7e1f5fd.ttf";